import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=1fd4e852&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=1fd4e852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd4e852",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fd4e852')) {
      api.createRecord('1fd4e852', component.options)
    } else {
      api.reload('1fd4e852', component.options)
    }
    module.hot.accept("./MainHeader.vue?vue&type=template&id=1fd4e852&scoped=true&", function () {
      api.rerender('1fd4e852', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/layout/MainHeader.vue"
export default component.exports